import React from "react";

const Banner = () => {
  return (
    <div className="flex flex-center bg-purple text-center text-fadedwhite-100 text-sm py-4">
      <div className="mx-auto w-5/6 screen-max-width">
        Get £140–£655 in credit towards iPhone 16 or iPhone 16 Pro when you
        trade in iPhone 12 or higher.{" "}
        <span className="relative align-top -underline-offset-4">*</span>
      </div>
    </div>
  );
};

export default Banner;
